import React from "react";
import { Box, Heading, List, ListItem, ListIcon } from "@chakra-ui/react";
import { CheckCircle } from "lucide-react";

const DeemedHighlightsSection = ({ highlights }) => {
 if (!highlights || highlights.length === 0) {
  return null;
 }

 return (
  <Box mb={8}>
   <Heading as="h2" size="md" mb={4}>
    College Highlights
   </Heading>

   <List spacing={3}>
    {highlights.map((highlight, index) => (
     <ListItem key={index} display="flex" alignItems="flex-start">
      <ListIcon
       as={CheckCircle}
       color="green.500"
       marginTop="0.2em"
       fontSize="1.2em"
      />
      {highlight}
     </ListItem>
    ))}
   </List>
  </Box>
 );
};

export default DeemedHighlightsSection;
